// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__LisYC","title":"ClientCherryInfo_title__3gPs1","itemText":"ClientCherryInfo_itemText__1xYXZ"};